module.exports = __webpack_public_path__ + "static/media/auth1.3f774d3c.svg";